import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";
import { Header, Footer } from "../components";
import { ChevronUp } from "lucide-react";

const PublicLayout = () => {
  const { pathname } = useLocation();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [isTop, setIsTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(currentScrollPos < 10 || prevScrollPos > currentScrollPos);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, visible]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Check is top
  useEffect(() => {
    const handleScroll = () => {
      setIsTop(window.scrollY < 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="w-full mx-auto h-full">
      <div className="w-full">
        {/* Header */}
        <header
          className={`sticky top-0 z-20 w-full transition-all duration-300 
          ${visible ? "visible" : "invisible"}
          ${visible ? "opacity-100" : "opacity-0"}
          `}
        >
          <Header />
        </header>

        {/* Content */}
        <Outlet />

        {/* Footer */}
        <Footer />

        {/* Scroll to top floating button */}
        <div
          className={`fixed bottom-8 right-8 max-md:bottom-4 max-md:right-4 z-50 transition-opacity duration-300 
          ${isTop ? "opacity-0" : "opacity-100"}`}
        >
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center justify-center w-12 h-12 bg-red-500 rounded-full shadow-lg outline-none border-2 border-primary-yellow"
          >
            <ChevronUp size={24} color="yellow" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicLayout;
